export default __webpack_public_path__ + "static/media/Liskov_logo.d033429a.svg";